import React, { useEffect, useState } from "react";
import { History, FileSpreadsheet } from "lucide-react";
import api from "../lib/api";
import { Modal, Badge } from "../lib/ui";
import { fmtRp, fmtNum } from "../lib/constants";
import { useT } from "../lib/i18n";

export default function SalesImportHistory({ open, onClose }) {
  const { t } = useT();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (open) {
      setRows(null);
      api.get("/sales/import/history").then(({ data }) => setRows(data.history || [])).catch(() => setRows([]));
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} size="lg" title={t("Import History")}>
      {rows === null ? (
        <div className="py-10 text-center text-sm text-ink-mute">{t("Loading…")}</div>
      ) : rows.length === 0 ? (
        <div className="flex flex-col items-center gap-2 py-10 text-ink-mute" data-testid="history-empty">
          <FileSpreadsheet size={28} /><p className="text-sm">{t("No import history yet")}</p>
        </div>
      ) : (
        <div className="max-h-[60vh] overflow-auto rounded-xl border border-line">
          <table className="w-full text-sm" data-testid="import-history-table">
            <thead className="sticky top-0 bg-stone-50"><tr className="text-left text-xs uppercase text-ink-mute">
              <th className="px-3 py-2">{t("When")}</th><th className="px-3 py-2">{t("File")}</th>
              <th className="px-3 py-2">{t("Branch")}</th><th className="px-3 py-2 text-right">{t("Imported")}</th>
              <th className="px-3 py-2 text-right">{t("Errors")}</th><th className="px-3 py-2 text-right">{t("Total Qty")}</th>
              <th className="px-3 py-2 text-right">{t("Gross")}</th><th className="px-3 py-2">{t("By")}</th></tr></thead>
            <tbody>
              {rows.map((h) => (
                <tr key={h.id} className="border-t border-line/60" data-testid={`history-row-${h.id}`}>
                  <td className="px-3 py-2 text-ink-soft">{(h.created_at || "").slice(0, 16).replace("T", " ")}</td>
                  <td className="px-3 py-2">
                    <span className="font-medium text-ink">{h.file_name || "—"}</span>
                    {h.template_name && <Badge tone="info" className="ml-1">{h.template_name}</Badge>}
                  </td>
                  <td className="px-3 py-2">{h.branch_label || "—"}</td>
                  <td className="px-3 py-2 text-right font-semibold text-success-text">{fmtNum(h.imported)}</td>
                  <td className="px-3 py-2 text-right">{h.error_rows ? <span className="text-danger-text">{fmtNum(h.error_rows)}</span> : "0"}</td>
                  <td className="px-3 py-2 text-right">{fmtNum(h.total_qty)}</td>
                  <td className="px-3 py-2 text-right">{h.total_gross ? fmtRp(h.total_gross) : "—"}</td>
                  <td className="px-3 py-2 text-ink-mute">{h.created_by_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  );
}
